// extracted by mini-css-extract-plugin
export var calendarView = "_mg-0";